// Country code mapping for dial codes and ISO codes
export const countryDialCodes = {
  'US': { dialCode: 1, name: 'United States' },
  'CA': { dialCode: 1, name: 'Canada' },
  'GB': { dialCode: 44, name: 'United Kingdom' },
  'UK': { dialCode: 44, name: 'United Kingdom' },
  'IN': { dialCode: 91, name: 'India' },
  'AU': { dialCode: 61, name: 'Australia' },
  'DE': { dialCode: 49, name: 'Germany' },
  'FR': { dialCode: 33, name: 'France' },
  'CN': { dialCode: 86, name: 'China' },
  'JP': { dialCode: 81, name: 'Japan' },
  'BR': { dialCode: 55, name: 'Brazil' },
  'MX': { dialCode: 52, name: 'Mexico' },
  'IT': { dialCode: 39, name: 'Italy' },
  'ES': { dialCode: 34, name: 'Spain' },
  'RU': { dialCode: 7, name: 'Russia' },
  'KR': { dialCode: 82, name: 'South Korea' },
  'NL': { dialCode: 31, name: 'Netherlands' },
  'SE': { dialCode: 46, name: 'Sweden' },
  'NO': { dialCode: 47, name: 'Norway' },
  'DK': { dialCode: 45, name: 'Denmark' },
  'FI': { dialCode: 358, name: 'Finland' },
  'PL': { dialCode: 48, name: 'Poland' },
  'BE': { dialCode: 32, name: 'Belgium' },
  'AT': { dialCode: 43, name: 'Austria' },
  'CH': { dialCode: 41, name: 'Switzerland' },
  'IE': { dialCode: 353, name: 'Ireland' },
  'NZ': { dialCode: 64, name: 'New Zealand' },
  'SG': { dialCode: 65, name: 'Singapore' },
  'HK': { dialCode: 852, name: 'Hong Kong' },
  'AE': { dialCode: 971, name: 'United Arab Emirates' },
  'SA': { dialCode: 966, name: 'Saudi Arabia' },
  'ZA': { dialCode: 27, name: 'South Africa' },
  'PK': { dialCode: 92, name: 'Pakistan' },
  'BD': { dialCode: 880, name: 'Bangladesh' },
  'MY': { dialCode: 60, name: 'Malaysia' },
  'TH': { dialCode: 66, name: 'Thailand' },
  'PH': { dialCode: 63, name: 'Philippines' },
  'VN': { dialCode: 84, name: 'Vietnam' },
  'ID': { dialCode: 234, name: 'Indonesia' },
  'EG': { dialCode: 20, name: 'Egypt' },
  'NG': { dialCode: 234, name: 'Nigeria' },
  'KE': { dialCode: 254, name: 'Kenya' },
  'AR': { dialCode: 54, name: 'Argentina' },
  'CL': { dialCode: 56, name: 'Chile' },
  'CO': { dialCode: 57, name: 'Colombia' },
  'PE': { dialCode: 51, name: 'Peru' },
  'TR': { dialCode: 90, name: 'Turkey' },
  'GR': { dialCode: 30, name: 'Greece' },
  'PT': { dialCode: 351, name: 'Portugal' },
  'CZ': { dialCode: 420, name: 'Czech Republic' },
  'HU': { dialCode: 36, name: 'Hungary' },
  'RO': { dialCode: 40, name: 'Romania' },
  'IL': { dialCode: 972, name: 'Israel' }
};

/**
 * Get dial code from country code
 * @param {string} countryCode - ISO country code (e.g., 'US', 'UK', 'PK')
 * @returns {number} Dial code
 */
export const getDialCodeFromCountry = (countryCode) => {
  const country = countryDialCodes[countryCode?.toUpperCase()];
  return country ? country.dialCode : 1; // Default to US
};

/**
 * Get country name from country code
 * @param {string} countryCode - ISO country code
 * @returns {string} Country name
 */
export const getCountryName = (countryCode) => {
  const country = countryDialCodes[countryCode?.toUpperCase()];
  return country ? country.name : 'United States';
};

/**
 * Format country codes for select dropdown
 * @returns {Array} Array of country code objects
 */
export const getCountryCodesForSelect = () => {
  const seen = new Set();
  return Object.entries(countryDialCodes)
    .filter(([code, data]) => {
      const key = `+${data.dialCode}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    })
    .map(([code, data]) => ({
      code: `+${data.dialCode}`,
      country: data.name,
      countryCode: code
    }));
};
